<template>
  <div class="new" id="newId">
    <div class="new-container">
      <!--        标题-->
      <div class="new-title">{{ $t('New.title') }}</div>
      <div class="new-line"></div>
      <div class="new-content">
        <!--          公司动态中间部分-->
        <div class="new-middle">
          <div class="company-text">{{ $t('New.company.text') }}</div>
          <div @click="goDetailFive()" class="new-middle-title ">中国银行青岛市分行——大数据营销专享用户系统</div>
          <div @click="goDetailFive()" class="new-middle-detail middle-title">
            当今时代既属于互联网，也属于大数据，伴随科技产品与生活的深度结合，让数据的汇总分析也变的更加高效便捷...
          </div>
          <div class="new-middle-line"></div>
          <div @click="goDetailSix()" class="new-middle-title ">极欧科技助力部分机关老年大学创办网络直播精品课堂</div>
          <div @click="goDetailThree()" class="new-middle-title ">思奇科技赋能中元保险互联网数字化营销新通路</div>
          <div @click="goDetailMore()" class="new-middle-btn">
            <button>了解更多</button>
          </div>
        </div>
        <div class="new-right">
          <img src="http://cdn-cus.weixinhai.net/cdn/web/img/house.57f45603.png"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "New",
  data() {
    return {
      index: 0  //替换
    }
  },
  methods: {
    goDetailSix() {
      this.$router.push('/detailsix')
    },
    goDetailFive(){
      this.$router.push('/detailfive')
    },
    goDetailFour() {
      this.$router.push('/detailfour')
    },
    goDetailThree() {
      this.$router.push('/detailthree')
    },
    goDetail() {
      this.$router.push('/detail')
    },
    goDetailTwo() {
      this.$router.push('/detailtwo')
    },
    goDetailMore() {
      this.$router.push('/detailmore')
    }
  }
}
</script>

<style scoped lang="less">

.new-container {
  width: 1200px;
  margin: 0 auto;
  padding-top: 120px;
  padding-bottom: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .new-title {
    font-size: 36px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
    line-height: 32px;
  }

  .new-line {
    margin-top: 30px;
    width: 40px;
    height: 4px;
    background: #2365D3;
  }

  .new-content {
    width: 98%;
    margin-top: 60px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    .new-company {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 214px;
      height: 197px;
      background-image: url('../assets/image/new/square.png');
      background-size: 100% 100%;
    }

    .company-lable {
      margin-top: 20px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 28px;
      opacity: 0.2;
    }

    .new-company-s {
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 214px;
      height: 394px;
      background-image: url('../assets/image/new/square-s.png');
      background-size: 100% 100%;
    }

    .new-middle {
      width: 100%;
      //background: #FFFFFF;
      border: NaNpx solid #EBEBEB;
      box-shadow: 0px 0px 20px 0px rgba(23, 69, 170, 0.1);
      margin-left: 20px;
      padding: 30px 40px;
      //margin-right: 20px;

      .new-middle-btn {
        padding-top: 40px;

        button {
          cursor: pointer;
          outline-style: none;
          border: 0;
          width: 191px;
          height: 51px;
          background: #2365D3;
          border-radius: 6px;
          color: white;
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: 400;
        }
      }

      .new-middle-line {
        width: 90%;
        height: 1px;
        background-color: #E2E2E2;
      }

      .company-text {
        width: 121px;
        font-size: 30px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #333333;
        //line-height: 60px;
        //padding: 20px 0;
      }

      .new-middle-title {
        cursor: pointer;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #2365D3;
        padding-top: 15px;
        //line-height: 28px;
      }

      .middle-title {
        padding-bottom: 30px;
      }

      .new-middle-detail {
        width: 85%;
        cursor: pointer;
        margin-top: 10px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #808080;
        //line-height: 21px;
      }

      .new-list {
        flex: 1;
        cursor: pointer;
        margin-top: 40px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;

        .new-round {
          width: 6px;
          height: 6px;
          background: #8D8D8D;
          border-radius: 100%;
          margin-right: 12px;
        }

        .new-middle-text {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #323232;
          line-height: 30px;
          flex: 1;
        }

        .new-time {
          padding-top: 20px;
          padding-left: 20px;
          font-size: 12px;
          color: #909090;
        }
      }

      .new-middle-content {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
      }

      .new-list:hover {
        .new-round {
          background-color: #248471;
        }

        .new-middle-text {
          color: #2365D3;
        }
      }

    }

    .new-right {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;

      img {
        width: 424px;
        height: 395px;
      }
    }
  }
}

@media (max-width: 1200px) {
  .new-container {
    width: 100%;
  }
}

@media (max-width: 480px) {
  .new-container {
    width: 100%;
    padding-top: 30px;
    padding-bottom: 30px;
    margin: 0 auto;

    .new-title {
      font-size: 28px;
    }

    .new-content {
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-wrap: wrap;
      margin-top: 30px;

      .new-company {
        width: 180px;
        height: 140px;

        .company-text {
          font-size: 18px;
        }

        .company-lable {
          font-size: 14px;
        }
      }

      .new-company-s {
        width: 180px;
        height: 140px;

        .company-text {
          font-size: 18px;
        }

        .company-lable {
          font-size: 14px;
        }
      }

      .new-right {
        margin-top: 20px;

        img {
          width: 162px;
          height: 148px;
        }
      }
    }
  }

  .new-left {
    display: flex;
    flex-direction: row;
  }

  .new-middle-title {
    padding-top: 20px;
  }

}

</style>
